export const STORIES_BASE_PATH = '/stories-of-us-lux';
export const ASSET_PREFIX = '/stories-of-us';

export const storiesOverviewRoutes = [`${STORIES_BASE_PATH}/record-gallery`, `${STORIES_BASE_PATH}/250-stories`];
